var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Whatsapp",
    clipPath: "url(#clip0_227_2155)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.946 4.39446C18.6899 2.13677 15.6899 0.892735 12.4936 0.891357C5.90715 0.891357 0.547109 6.24968 0.544472 12.8358C0.543705 14.9411 1.09379 16.9962 2.13935 18.8077L0.444153 24.9974L6.77851 23.3365C8.52375 24.2883 10.4888 24.7898 12.4884 24.7906H12.4935H12.4936C19.079 24.7906 24.4398 19.4313 24.4426 12.8455C24.4437 9.65355 23.2019 6.65232 20.946 4.39446ZM12.4936 22.7731H12.4897C10.7073 22.7722 8.95941 22.2937 7.43482 21.389L7.07199 21.1739L3.31305 22.1595L4.31664 18.4959L4.08024 18.1203C3.08601 16.5394 2.56113 14.7125 2.56188 12.8366C2.56406 7.3624 7.01912 2.9089 12.4973 2.9089C15.1502 2.91 17.6436 3.94405 19.5188 5.82058C21.3939 7.69709 22.4258 10.1917 22.425 12.8447C22.4227 18.319 17.9675 22.7731 12.4936 22.7731Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.992188 24.3108L2.60995 18.4038C1.61189 16.675 1.08704 14.7137 1.08767 12.705C1.09028 6.41981 6.20552 1.3064 12.4906 1.3064C15.541 1.30777 18.404 2.49492 20.5566 4.64954C22.7097 6.80414 23.8947 9.66808 23.8934 12.7139C23.8908 18.9992 18.7752 24.1131 12.491 24.1131C12.4906 24.1131 12.4913 24.1131 12.491 24.1131H12.4859C10.5776 24.1125 8.70249 23.6334 7.03708 22.7258L0.992188 24.3108Z",
    fill: "url(#paint0_linear_227_2155)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.54083 7.7648C9.31976 7.2733 9.08701 7.26346 8.87669 7.25486C8.70466 7.24748 8.50773 7.24793 8.3111 7.24793C8.11432 7.24793 7.79455 7.32188 7.52413 7.61721C7.25356 7.91254 6.49103 8.62648 6.49103 10.0785C6.49103 11.5307 7.54873 12.9339 7.69616 13.1309C7.84374 13.3277 9.73793 16.4027 12.7378 17.5857C15.2309 18.5689 15.7382 18.3733 16.2794 18.3241C16.8205 18.2749 18.0255 17.6103 18.2715 16.9211C18.5175 16.2321 18.5175 15.6414 18.4437 15.518C18.3699 15.395 18.1731 15.3212 17.8779 15.1736C17.5827 15.026 16.1318 14.3119 15.8612 14.2135C15.5906 14.1151 15.3939 14.0659 15.1971 14.3614C15.0003 14.6566 14.435 15.3212 14.2628 15.518C14.0906 15.7152 13.9185 15.7398 13.6233 15.5922C13.3281 15.4442 12.3776 15.1329 11.2499 14.1274C10.3725 13.3452 9.78019 12.3791 9.60801 12.0837C9.43583 11.7885 9.58955 11.6286 9.73761 11.4815C9.87012 11.3493 10.0328 11.1369 10.1804 10.9646C10.3276 10.7923 10.3768 10.6693 10.4752 10.4725C10.5736 10.2754 10.5244 10.1031 10.4506 9.95549C10.3768 9.8079 9.80326 8.34837 9.54083 7.7648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.8484 4.35646C18.6182 2.12468 15.6526 0.894952 12.493 0.893555C5.98219 0.893555 0.683685 6.19036 0.681067 12.7009C0.6803 14.782 1.22407 16.8135 2.25762 18.6042L0.581909 24.7229L6.84356 23.081C8.56878 24.0218 10.5112 24.5176 12.488 24.5184H12.493H12.493C19.0028 24.5184 24.3021 19.2207 24.3049 12.7104C24.3059 9.55517 23.0784 6.5884 20.8484 4.35646ZM12.493 22.5242H12.4892C10.7272 22.5232 8.9994 22.0502 7.49233 21.1559L7.13366 20.9433L3.41787 21.9175L4.40992 18.296L4.17624 17.9247C3.19342 16.362 2.67456 14.556 2.67533 12.7017C2.67748 7.29035 7.08139 2.88798 12.4967 2.88798C15.1192 2.88906 17.5839 3.91124 19.4376 5.76622C21.2912 7.6212 22.3112 10.0871 22.3105 12.7097C22.3081 18.1212 17.9041 22.5242 12.493 22.5242Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_227_2155",
    x1: 12.4428,
    y1: 24.3108,
    x2: 12.4428,
    y2: 1.30643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20B038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D66A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_227_2155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24.1061,
    fill: "white",
    transform: "translate(0.443359 0.891357)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/Whatsapp.3c296902863ef1cb2235b69e41f11d43.svg";
export { ForwardRef as ReactComponent };